import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { useStaticQuery, graphql } from "gatsby";
import Spinner from "react-spinkit";
import { useIntl, IntlContextConsumer } from "gatsby-plugin-intl";
import { trackCustomEvent } from "gatsby-plugin-google-analytics";

import { getImageKey, getVariantFromCurFrame } from "../../utils";
import { GlobalDispatchContext, GlobalStateContext } from "Components/context";

const StyledButton = styled.div`
  text-align: center;
  background-color: black;
  color: white;
  font-family: ${(props) => props.theme.font.sans};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3.6rem;
  font-size: 1rem;
  font-weight: bold;
  border-radius: 3px;
  flex: 1;
  border: 1rem black solid;
  pointer-events: ${(props) =>
    props.isLoading || props.isDisabled ? "none" : "auto"};

  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`;

const WrappedSpinner = ({ isLoading, ...props }) => {
  return <Spinner {...props} />;
};

const StyledSpinner = styled(WrappedSpinner)`
  display: ${(props) => (props.isLoading ? "block" : "none")};
  margin: auto;
  height: 20px;
  width: 20px;
`;

const BuyButton = ({
  bagFrames,
  frameFrontShots,
  isDisabled = false,
  ...props
}) => {
  const state = useContext(GlobalStateContext);
  const dispatch = useContext(GlobalDispatchContext);
  const { allShopifyProductVariant, site } = useStaticQuery(graphql`
    query {
      allShopifyProductVariant(filter: { requiresShipping: { eq: true } }) {
        edges {
          node {
            price
            shopifyId
            sku
            selectedOptions {
              name
              value
            }
            title
          }
        }
      }
      site {
        siteMetadata {
          url
        }
      }
    }
  `);
  const intl = useIntl();
  const [isCTALoading, setIsCTALoading] = useState(false);

  const shopifyCheckout = (locale) => {
    trackCustomEvent({
      category: "Initiate Checkout Button",
      action: "Click",
      value: state.shopifyCheckout.totalPriceV2.amount,
    });
    window.location = state.shopifyCheckout.webUrl + `&locale=${locale}`;
  };

  const zonosCheckout = async (bagFrames) => {
    let items = bagFrames.map((bagFrame) => {
      let curVariant = getVariantFromCurFrame(
        bagFrame,
        allShopifyProductVariant
      );
      return {
        lensName: bagFrame.selectedLens.name.en,
        colorName: bagFrame.selectedFrameColor.name.en,
        productId: bagFrame.name,
        description: curVariant.title,
        imageURL: `${site.siteMetadata.url}${
          frameFrontShots[getImageKey(bagFrame.sku, bagFrame)].url
        }`,
        quantity: 1,
        unitPrice: bagFrame.price,
        sku: curVariant.sku,
        skuType: bagFrame.sku,
      };
    });
    let checkoutPayload = {
      items: items,
      storeId: 2753,
      externalConfirmationPageURL: `${site.siteMetadata.url}/orderConfirmed/`,
    };

    fetch(`${process.env.GATSBY_KC_ENDPOINT}/zonos/create_checkout`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(checkoutPayload),
    })
      .then((response) => response.json())
      .then((data) => {
        let link = `https://kingchildren.iglobalstores.com/?tempCartUUID=${data.data.cart_uuid}`;
        trackCustomEvent({
          category: "Initiate Checkout Button",
          action: "Click",
          value: items.reduce((acc, i) => acc + parseFloat(i.unitPrice), 0),
        });
        if (typeof window !== "undefined") {
          if (window.fbq != null) {
            window.fbq("track", "Initiate Checkout", {
              value: items.reduce((acc, i) => acc + parseFloat(i.unitPrice), 0),
            });
          }
        }
        window.location.href = link; // TODO UNDO
        setIsCTALoading(false);
      })
      .catch((e) => {
        setIsCTALoading(false);
      });
  };

  const handleBuy = (bagFrames, locale) => {
    if (!isCTALoading) {
      setIsCTALoading(true);
      // zonosCheckout(bagFrames)
      shopifyCheckout(locale);
    }
  };

  return (
    <IntlContextConsumer>
      {({ languages, language: currentLocale }) => (
        <StyledButton
          isLoading={isCTALoading}
          onClick={() => handleBuy(bagFrames, currentLocale)}
          isDisabled={isDisabled}
        >
          {isCTALoading ? (
            <StyledSpinner
              fadeIn="none"
              isLoading={isCTALoading}
              color="white"
              name="cube-grid"
            />
          ) : (
            <>{intl.formatMessage({ id: `buyPopup.summary.buy` })}</>
          )}
        </StyledButton>
      )}
    </IntlContextConsumer>
  );
};

export default BuyButton;
